module.exports = __webpack_public_path__ + "img/icon2.3b735731.png";